import { useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";
import { useSelector } from "react-redux";
import PaginationBar from "../../Components/PaginationBar";
import NoResult from "../../Components/NoResult";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TIMEOUT } from "../../Features/dateTime";
import Loader from "../../Components/Loader";
import * as api from "../../api/getapi";
import useApi from "../../Hooks/useApi";
import * as postapi from "../../api/postapi";
import OrdersReasonModal from "./OrdersReasonModal";
import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import SendSmsModal from "../../Components/Orders/SendSmsModal";
import MarkSpamModal from "../../Components/Orders/MarkSpamModal";
import ToggleDummyModal from "../../Components/Orders/ToggleDummyModal";
import OrdersWorkspace from "../../Components/Orders/OrdersWorkspace/OrdersWorkspace";
import OrdersControls from "../../Components/Orders/OrdersToolbar/OrdersControls";
import { createOrderFilterDefaults } from "../../Components/Orders/OrdersToolbar/orderFilterModel";
import { TRX_METHOD, normalizePaymentStatus, PAYMENT_STATUS } from "../../constants/orders";
import chevronDown from "../../assets/svg/chevron-down.svg";
import chevronUp from "../../assets/svg/chevronUp.svg";

// Order source status constants
const OrderSourceStatus = {
  PENDING: "Pending",
  VERIFYING_PAYMENT: "Verifying Payment",
  CONFIRMED: "Confirmed",
  PICKED: "Picked",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
  PAYMENT_FAILED: "Payment Failed",
  RETURNED: "Returned",
  REFUNDED: "Refunded",
};

// Order status constants - now comes from backend API
const OrderStatus = {
  PENDING: "Pending",
  VERIFYING_PAYMENT: "Verifying Payment",
  IN_PROGRESS: "In Progress",
  PARTIALLY_FULFILLED: "Partially Fulfilled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  PAYMENT_FAILED: "Payment Failed",
};

const OrdersPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const fetchAllCategories = useApi(api.fetchAllCategories);
  const fetchAllOrders = useApi(api.fetchAllOrders, { hasCatchError: true });

  const { user } = useSelector((state) => state.auth);
  const shop_id = user.shop_id;
  const [filterDefaults] = useState(() => createOrderFilterDefaults());

  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(filterDefaults.pageSize);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState(filterDefaults.search);
  const [toggle, refresh] = useState(false);
  const [statusSearch, setStatusSearch] = useState(filterDefaults.status);
  const [paymentMethodSearch, setPaymentMethodSearch] = useState(filterDefaults.paymentMethod);
  const [includeDummy, setIncludeDummy] = useState(filterDefaults.includeDummy);
  const [isLoading, setIsLoading] = useState(true);
  const [orderBy, setOrderBy] = useState({ created_at: "DESC" });
  const [category, setCategory] = useState(filterDefaults.category);
  const [orders, setOrders] = useState([]);
  const [ordersData, setOrdersData] = useState({});
  const [totalOrders, setTotalOrders] = useState();
  const [fromDate, setFromDate] = useState(filterDefaults.fromDate);
  const [toDate, setToDate] = useState(filterDefaults.toDate);
  const [reasonModal, setReasonModal] = useState(false);
  const [orderReason, setOrderReason] = useState({
    order_source_id: null,
    order_id: null,
    status: null,
  });
  const [paymentGatewayResponse, setPaymentGatewayResponse] = useState(null);
  const [phoneSearch, setPhoneSearch] = useState(filterDefaults.phone);
  const [changeStatusModal, setChangeStatusModal] = useState(false);
  const [isActionPerforming, setIsActionPerforming] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [mobileOrderOpen, setMobileOrderOpen] = useState(false);
  const [workspaceMovingItems, setWorkspaceMovingItems] = useState({});

  const selectedOrder = orders.find((order) => order.id === selectedOrderId) || orders[0] || null;

  useEffect(() => {
    if (orders.length > 0 && !orders.some((order) => order.id === selectedOrderId)) {
      setSelectedOrderId(orders[0].id);
    }
  }, [orders, selectedOrderId]);

  // Search Products
  const searchHandle = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      setSearch("");
    } else {
      setSearch(e.target.value);
    }
    setCurrentPage(1);
  };

  const searchStatus = (e) => {
    if (e.value) {
      setStatusSearch({ value: e.value, label: e.label });
    } else {
      setStatusSearch({ value: null, label: "All Statuses" });
    }
    setCurrentPage(1);
  };

  const searchPaymentMethod = (e) => {
    if (e.value) {
      setPaymentMethodSearch({ value: e.value, label: e.label });
    } else {
      setPaymentMethodSearch({ value: null, label: "All Payment Methods" });
    }
    setCurrentPage(1);
  };

  const getCat = async () => {
    return new Promise((resolve, reject) => {
      fetchAllCategories
        .request()
        .then((res) => {
          const getData = res.data.data
            .filter((cat) => cat.id !== 7)
            .map((cat) => ({
              value: cat.id,
              label: cat.category,
            }));
          getData.splice(0, 0, { value: null, label: "All" });
          resolve(getData);
        })
        .catch((err) => {
          reject("err" + err);
        });
    });
  };
  const filterCategories = (e) => {
    if (e.value) {
      setCategory({ value: e.value, label: e.label });
    } else {
      setCategory(null);
    }
    setCurrentPage(1);
  };

  const resetFilterHandle = () => {
    setSearch(filterDefaults.search);
    setPhoneSearch(filterDefaults.phone);
    setStatusSearch(filterDefaults.status);
    setPaymentMethodSearch(filterDefaults.paymentMethod);
    setCategory(filterDefaults.category);
    setFromDate(filterDefaults.fromDate);
    setToDate(filterDefaults.toDate);
    setSizeOfPages(filterDefaults.pageSize);
    setIncludeDummy(filterDefaults.includeDummy);
    setCurrentPage(1);
  };

  const clearOrderFilter = (key) => {
    const clearers = {
      search: () => setSearch(filterDefaults.search),
      phone: () => setPhoneSearch(filterDefaults.phone),
      status: () => setStatusSearch(filterDefaults.status),
      paymentMethod: () => setPaymentMethodSearch(filterDefaults.paymentMethod),
      category: () => setCategory(filterDefaults.category),
      dateRange: () => {
        setFromDate(filterDefaults.fromDate);
        setToDate(filterDefaults.toDate);
      },
      pageSize: () => setSizeOfPages(filterDefaults.pageSize),
      includeDummy: () => setIncludeDummy(filterDefaults.includeDummy),
    };
    clearers[key]?.();
    setCurrentPage(1);
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  //searchParams
  useEffect(() => {
    if (searchParams.get("page")) {
      setCurrentPage(Number(searchParams.get("page")));
    }
  }, [currentPage, toggle, searchParams]);

  function getDeliverForYouOrders() {
    try {
      let phoneNumber = phoneSearch.replaceAll("_", "");
      if (phoneNumber.endsWith("-")) {
        phoneNumber = phoneNumber.slice(0, -1);
      }
      fetchAllOrders
        .request({
          page: currentPage,
          size: sizeOfPages,
          search: search,
          status: statusSearch,
          category: category,
          fromDate: fromDate,
          toDate: toDate,
          orderBy: orderBy,
          phone: phoneNumber,
          paymentMethod: paymentMethodSearch.value,
          includeDummy: includeDummy ? true : undefined,
        })
        .then((data) => {
          setIsLoading(false);
          setTotalOrders(data?.data?.pagination?.no_of_items);
          setOrders(data?.data?.data);

          if (data?.data?.pagination?.no_of_pages === 0) {
            if (searchParams.get("page")) {
              setNoOfPages(0);
              navigate("/delivery-for-you-orders?page=0");
            }
          } else {
            setNoOfPages(data?.data?.pagination?.no_of_pages);
            if (currentPage > data?.data?.pagination?.no_of_pages) {
              setCurrentPage(data?.data?.pagination?.no_of_pages);
              navigate("/delivery-for-you-orders?page=" + data?.data?.pagination?.no_of_pages);
            }
            if (searchParams.get("page") === "0") {
              setCurrentPage(1);
              navigate("/delivery-for-you-orders?page=1");
            }
          }
        })
        .catch((err) => {
          const tempErr = err.response.data.error;

          if (tempErr.status === 404 && tempErr.message === "No Record Found") {
            setOrders([]);
            setIsLoading(false);
          }
        });
    } catch (err) {
      const tempErr = err.response.data.error;

      if (tempErr.status === 404 && tempErr.message === "No Record Found") {
        setOrders([]);
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    let timeout;
    if (search?.length > 0) {
      timeout = setTimeout(() => {
        setIsLoading(true);
        getDeliverForYouOrders();
      }, TIMEOUT);
    } else {
      setIsLoading(true);
      getDeliverForYouOrders();
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [search, fromDate, toDate, currentPage, noOfPages, sizeOfPages, statusSearch, shop_id, toggle, orderBy, category, phoneSearch, paymentMethodSearch]);

  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, [search, fromDate, toDate, statusSearch, category, phoneSearch, paymentMethodSearch, sizeOfPages]);

  const OrderCaretData = ({ order }) => {
    const [expandedOrderSources, setExpandedOrderSources] = useState({});
    const [expandedOrderItems, setExpandedOrderItems] = useState({});
    const [movingItems, setMovingItems] = useState({});

    const toggleOrderSource = (orderSourceId) => {
      setExpandedOrderSources((prev) => ({
        ...prev,
        [orderSourceId]: !prev[orderSourceId],
      }));
    };

    const toggleOrderItems = (orderSourceId) => {
      setExpandedOrderItems((prev) => ({
        ...prev,
        [orderSourceId]: !prev[orderSourceId],
      }));
    };

    const moveItemToTechbazaarMall = async (order_id, itemId, cost_price_per_item) => {
      try {
        setMovingItems((prev) => ({
          ...prev,
          [itemId]: true,
        }));

        await postapi.moveD4uOrderToTM({
          // order_id: order_id,
          order_item_id: itemId,
          cost_price_per_item: cost_price_per_item,

          //
        });

        toast.success("Order Item moved to Techbazaar Mall successfully", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        refreshHandle();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.error?.message || "Failed to move order item to Techbazaar Mall", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } finally {
        setMovingItems((prev) => ({
          ...prev,
          [itemId]: false,
        }));
      }
    };

    return (
      <div className="p-3">
        <Row className="mb-3">
          <Col md={6}>
            <p>
              <strong>Customer Name:</strong> {order.customer_name}
            </p>
            <p>
              <strong>Email:</strong> {order.customer_email}
            </p>
            <p>
              <strong>Phone:</strong> {order.customer_phone}
            </p>
            <p>
              <strong>Address:</strong> {order.customer_address}
            </p>
            {order.near_landmark && (
              <p>
                <strong>Near Landmark:</strong> {order.near_landmark}
              </p>
            )}
          </Col>
          <Col md={6}>
            <p>
              <strong>Order Number:</strong> {order.order_number}
            </p>
            <p>
              <strong>Grand Total:</strong> PKR {order.grand_total}
            </p>
            <p>
              <strong>Payment Method:</strong> {order.trx_method}
            </p>
            <p>
              <strong>Payment Status:</strong> {order.trx_status}
            </p>
          </Col>
        </Row>

        {order.order_sources && order.order_sources.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">
              Order Sources ({order.order_sources.length} Shop{order.order_sources.length > 1 ? "s" : ""}):
            </h6>
            {order.order_sources.map((orderSource, idx) => {
              const nextStatus = getNextStatus(orderSource.status);
              const isSoldOut = orderSource.is_sold_out === 1 || orderSource.is_sold_out === true;
              const isPickedDisabled = nextStatus === OrderSourceStatus.PICKED && !isSoldOut;

              return (
                <div key={orderSource.order_source_id} className="border rounded mb-3 p-3" style={{ backgroundColor: "#f8f9fa" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <button type="button" className="btn btn-link p-0 me-2 border-0" onClick={() => toggleOrderSource(orderSource.order_source_id)} style={{ boxShadow: "none" }}>
                        <img src={expandedOrderSources[orderSource.order_source_id] ? chevronUp : chevronDown} alt="toggle order source" />
                      </button>
                      <h6 className="mb-0">
                        <strong>{orderSource.shop_name}</strong> - PKR {orderSource.amount} ({orderSource.order_items.length} item{orderSource.order_items.length !== 1 ? "s" : ""})
                      </h6>
                    </div>
                    <div>
                      <span
                        className={`badge ${
                          orderSource.status === "Delivered"
                            ? "bg-success"
                            : orderSource.status === "Pending"
                              ? "bg-warning"
                              : orderSource.status === "Cancelled"
                                ? "bg-danger"
                                : orderSource.status === "Picked"
                                  ? "bg-info"
                                  : orderSource.status === "Confirmed"
                                    ? "bg-primary"
                                    : orderSource.status === "Shipped"
                                      ? "bg-secondary"
                                      : "bg-dark"
                        }`}
                      >
                        {orderSource.status}
                      </span>
                    </div>
                  </div>

                  {expandedOrderSources[orderSource.order_source_id] && (
                    <div className="mt-3">
                      <Row>
                        <Col md={12} className="mb-2">
                          <p className="mb-1">
                            <strong>Shop ID:</strong> {orderSource.shop_id}
                          </p>
                          <p className="mb-1">
                            <strong>Location ID:</strong> {orderSource.location_id}
                          </p>
                          <p className="mb-1">
                            <strong>Delivery Charges:</strong> PKR {orderSource.delivery_charges}
                          </p>
                          {orderSource.discount_value && (
                            <p className="mb-1">
                              <strong>Discount:</strong> PKR {orderSource.discount_value}
                            </p>
                          )}
                        </Col>
                      </Row>

                      <div className="d-flex gap-2 mb-3">
                        {orderSource.status !== "Cancelled" && orderSource.status !== "Delivered" && orderSource.status !== "Returned" && order.is_spam === 0 && (
                          <>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              disabled={isPickedDisabled}
                              onClick={() => {
                                handleStatusModal({
                                  ...order,
                                  ...orderSource,
                                  order_source_id: orderSource.order_source_id,
                                });
                              }}
                            >
                              {nextStatus || "Update Status"}
                            </Button>
                            <Button size="sm" variant="outline-danger" onClick={() => reasonHandle(orderSource.order_source_id, "Cancelled")}>
                              Cancel
                            </Button>
                          </>
                        )}

                        {/* courier tracking actions */}
                        {orderSource.tracking_id && orderSource.status === "Shipped" && ["PostEx", "TCS"].includes(orderSource.delivery_partner_name) && (
                          <>
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              onClick={async () => {
                                try {
                                  const res =
                                    orderSource.delivery_partner_name === "TCS"
                                      ? await postapi.getOrderTcsLabel(orderSource.tracking_id)
                                      : await postapi.getOrderPostexAirwayBill(orderSource.tracking_id);
                                  const blob = new Blob([res.data], { type: "application/pdf" });
                                  const url = URL.createObjectURL(blob);
                                  const link = document.createElement("a");
                                  link.href = url;
                                  link.download = `airway-bill-${orderSource.tracking_id}.pdf`;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  URL.revokeObjectURL(url);
                                } catch (err) {
                                  toast.error("Failed to download airway bill.");
                                }
                              }}
                            >
                              Airway Bill
                            </Button>

                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>
                                  <div style={{ fontSize: "11px", fontWeight: 600 }}>{orderSource.delivery_partner_name} Tracking</div>
                                  <div style={{ fontSize: "12px", letterSpacing: "0.5px" }}>{orderSource.tracking_id}</div>
                                  <div style={{ fontSize: "10px", opacity: 0.8 }}>Click to copy</div>
                                </Tooltip>
                              }
                            >
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                style={{ lineHeight: 1, padding: "4px 7px" }}
                                onClick={() => {
                                  navigator.clipboard
                                    .writeText(orderSource.tracking_id)
                                    .then(() => {
                                      toast.success(`Tracking number copied: ${orderSource.tracking_id}`, {
                                        position: "bottom-right",
                                        autoClose: 1500,
                                        hideProgressBar: true,
                                      });
                                    })
                                    .catch(() => {
                                      toast.error("Failed to copy tracking number.");
                                    });
                                }}
                              >
                                <FontAwesomeIcon icon={faCopy} style={{ fontSize: "12px" }} />
                              </Button>
                            </OverlayTrigger>
                          </>
                        )}
                        {orderSource.status === "Shipped" && (
                          <>
                            <Button size="sm" onClick={() => reasonHandle(orderSource.order_source_id, "Returned")}>
                              Returned
                            </Button>
                          </>
                        )}
                      </div>

                      {orderSource.order_items && orderSource.order_items.length > 0 && (
                        <div className="mt-2">
                          <div className="d-flex align-items-center mb-2">
                            <button type="button" className="btn btn-link p-0 me-2 border-0" onClick={() => toggleOrderItems(orderSource.order_source_id)} style={{ boxShadow: "none" }}>
                              <img src={expandedOrderItems[orderSource.order_source_id] ? chevronUp : chevronDown} alt="toggle order items" />
                            </button>
                            <strong>Order Items ({orderSource.order_items.length})</strong>
                          </div>

                          {expandedOrderItems[orderSource.order_source_id] && (
                            <Table striped bordered size="sm" className="mb-0">
                              <thead>
                                <tr>
                                  <th>Product</th>
                                  <th>Condition</th>
                                  <th>Category</th>
                                  <th>Online Price</th>
                                  <th>Discount</th>
                                  <th>Price</th>
                                  <th>Qty</th>
                                  <th>Bank Transfer Discount</th>
                                  <th>Delivery Charges</th>
                                  <th>Voucher Discount</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {orderSource.order_items.map((item) => (
                                  <tr key={item.order_item_id}>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        {item.product_primary_image && <img src={`${process.env.REACT_APP_URL_S3}/${item.product_primary_image}`} alt={item.product_title} width="40" height="40" className="me-2" style={{ objectFit: "cover", borderRadius: "4px" }} />}
                                        <span style={{ fontSize: "12px" }}>{item.product_title}</span>
                                      </div>
                                    </td>
                                    <td>{item.condition}</td>
                                    <td>{item.category}</td>
                                    <td>PKR {item.online_price}</td>
                                    <td>PKR {item.discount_value}</td>
                                    <td>PKR {item.original_price}</td>
                                    <td>{item.quantity}</td>
                                    <td>PKR {item.order_item_bank_transfer_discount}</td>
                                    <td>PKR {item.delivery_charges}</td>
                                    <td>PKR {item.voucher_discount}</td>
                                    <td>
                                      {orderSource.shop_name?.toLowerCase() !== "techbazaar mall" && orderSource.status === "Pending" && (
                                        <Button
                                          size="sm"
                                          variant="outline-primary"
                                          disabled={!!movingItems[item.order_item_id]}
                                          onClick={() => {
                                            moveItemToTechbazaarMall(order.id, item.order_item_id, item.original_price);
                                          }}
                                        >
                                          {movingItems[item.order_item_id] ? "Moving..." : "Move to TM"}
                                        </Button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const caret = async (orderId) => {
    const data = orders.filter((item) => item.id === orderId);
    const order = data[0];
    setOrdersData(<OrderCaretData order={order} />);
  };
  const reasonHandle = (id, status) => {
    if (status === "Cancelled" || status === "Returned") {
      setReasonModal(true);
      setOrderReason({
        order_source_id: id,
        order_id: null,
        status: status,
      });
    }
  };

  const FetchOrderByRRN = async (orderId) => {
    try {
      const res = await axios.get(`https://payments.bankalfalah.com/HS/api/IPN/OrderStatus/210743/399691/${orderId}`, {
        headers: {
          Accept: "application/json",
        },
      });
      return res;
    } catch (error) {
      console.error("Error fetching order by RRN:", error);
      throw error;
    }
  };

  const getNextStatus = (currentStatus) => {
    const statusMap = {
      "Verifying Payment": "Confirmed",
      Pending: "Confirmed",
      Confirmed: "Picked",
      Picked: "Shipped",
      Shipped: "Delivered",
    };
    return statusMap[currentStatus] || null;
  };

  const refreshHandle = () => {
    refresh((prev) => !prev);
  };
  const handleStatusModal = (value) => {
    const orderSourceId = value["order_source_id"];
    const parentOrderId = value["order_id"] || value["id"] || null;

    if (value["trx_method"] === TRX_METHOD.CASH) {
      const nextStatus = getNextStatus(value["status"]);
      if (nextStatus) {
        setChangeStatusModal(true);
        setOrderReason({
          order_source_id: orderSourceId,
          order_id: parentOrderId,
          status: nextStatus,
        });
      }
    } else if (value["trx_method"] === TRX_METHOD.CARD || value["trx_method"] === TRX_METHOD.CARD_BNPL || value["trx_method"] === TRX_METHOD.RAAST) {
      setIsActionPerforming(true);
      FetchOrderByRRN(value["order_number"])
        .then((res) => {
          const data = JSON.parse(res.data);
          // Normalize status from either Abhipay or Alfalah gateway
          const normalizedTrxStatus = normalizePaymentStatus(data?.TransactionStatus);
          const nextStatus = getNextStatus(value["status"]);

          if (!nextStatus) {
            setIsActionPerforming(false);
            return;
          }

          // Store the gateway response to show in modal
          setPaymentGatewayResponse(data);
          setChangeStatusModal(true);

          // If payment status changed or it's the first verification, include trx_status
          if (normalizedTrxStatus !== value["trx_status"] || value["status"] === "Verifying Payment" || value["status"] === "Pending") {
            setOrderReason({
              order_source_id: orderSourceId,
              order_id: parentOrderId,
              status: nextStatus,
              trx_status: normalizedTrxStatus,
            });
          } else {
            setOrderReason({
              order_source_id: orderSourceId,
              order_id: parentOrderId,
              status: nextStatus,
            });
          }

          setIsActionPerforming(false);
        })
        .catch((error) => {
          console.error("Failed to fetch order status:", error);
          setIsActionPerforming(false);
          setPaymentGatewayResponse(null);
          // Optionally show error notification to user
        });
    } else if (value["trx_method"] === TRX_METHOD.BANK_TRANSFER) {
      const nextStatus = getNextStatus(value["status"]);
      if (nextStatus) {
        setChangeStatusModal(true);
        setOrderReason({
          order_source_id: orderSourceId,
          order_id: parentOrderId,
          status: nextStatus,
        });
      }
    }
  };

  const [smsModalState, setSmsModaState] = useState(null);
  const [smsModalShow, setSmsModalShow] = useState(false);
  const [spamModalShow, setSpamModalShow] = useState(false);
  const [spamModalMode, setSpamModalMode] = useState("mark");
  const [dummyModalShow, setDummyModalShow] = useState(false);
  const [dummyModalMode, setDummyModalMode] = useState("mark");

  const closeSmsModal = () => {
    setSmsModalShow(false);
    setSmsModaState(null);
  };

  const closeSpamModal = () => {
    setOrdersData(null);
    setSpamModalShow(false);
    setSpamModalMode("mark");
  };

  const closeDummyModal = () => {
    setOrdersData(null);
    setDummyModalShow(false);
    setDummyModalMode("mark");
  };

  const selectWorkspaceOrder = (orderId) => {
    setSelectedOrderId(orderId);
    setMobileOrderOpen(true);
  };

  const moveWorkspaceItemToMall = async (order, source, item) => {
    const itemId = item.order_item_id;
    try {
      setWorkspaceMovingItems((current) => ({ ...current, [itemId]: true }));
      await postapi.moveD4uOrderToTM({
        order_item_id: itemId,
        cost_price_per_item: item.original_price,
      });
      toast.success("Order Item moved to Techbazaar Mall successfully", {
        position: "bottom-right",
        autoClose: 1500,
      });
      refreshHandle();
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Failed to move order item to Techbazaar Mall", {
        position: "bottom-right",
        autoClose: 2000,
      });
    } finally {
      setWorkspaceMovingItems((current) => ({ ...current, [itemId]: false }));
    }
  };

  const downloadWorkspaceAirwayBill = async (source) => {
    try {
      const response =
        source.delivery_partner_name === "TCS"
          ? await postapi.getOrderTcsLabel(source.tracking_id)
          : await postapi.getOrderPostexAirwayBill(source.tracking_id);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `airway-bill-${source.tracking_id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Failed to download airway bill");
    }
  };

  const copyWorkspaceTracking = async (source) => {
    try {
      await navigator.clipboard.writeText(source.tracking_id);
      toast.success("Tracking number copied");
    } catch (error) {
      toast.error("Unable to copy tracking number");
    }
  };

  return (
    <>
      <Container fluid>
        <OrdersControls
          totalOrders={totalOrders || 0}
          defaults={filterDefaults}
          values={{
            search,
            phone: phoneSearch,
            status: statusSearch,
            paymentMethod: paymentMethodSearch,
            category,
            fromDate,
            toDate,
            pageSize: sizeOfPages,
            includeDummy,
          }}
          categoryOptions={getCat}
          handlers={{
            onSearchChange: searchHandle,
            onPhoneChange: (event) => {
              setPhoneSearch(event.target.value);
              setCurrentPage(1);
            },
            onDateFromChange: setFromDate,
            onDateToChange: setToDate,
            onCategoryChange: filterCategories,
            onStatusChange: searchStatus,
            onPaymentMethodChange: searchPaymentMethod,
            onPageSizeChange: (option) => {
              setSizeOfPages(Number(option.value));
              setCurrentPage(1);
            },
            onToggleDummy: (e) => {
              setIncludeDummy(e.target.checked);
              setCurrentPage(1);
            },
            onClearFilter: clearOrderFilter,
            onReset: resetFilterHandle,
            onRefresh: () => refresh((previous) => !previous),
            onCreateOrder: () => navigate("/orders/create"),
          }}
        />

        {isLoading ? (
          <div
            style={{
              height: "50vh",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>
        ) : orders?.length === 0 ? (
          <NoResult />
        ) : (
          <>
            <OrdersWorkspace
              orders={orders}
              selectedOrder={selectedOrder}
              selectedOrderId={selectedOrder?.id}
              onSelectOrder={selectWorkspaceOrder}
              onMobileBack={() => setMobileOrderOpen(false)}
              mobileOrderOpen={mobileOrderOpen}
              totalOrders={totalOrders}
              actionProps={{
                onSendSms: (order) => {
                  setSmsModaState(order);
                  setSmsModalShow(true);
                },
                onMarkSpam: (order) => {
                  setOrdersData(order);
                  setSpamModalMode("mark");
                  setSpamModalShow(true);
                },
                onRemoveSpam: (order) => {
                  setOrdersData(order);
                  setSpamModalMode("unmark");
                  setSpamModalShow(true);
                },
                onMarkDummy: (order) => {
                  setOrdersData(order);
                  setDummyModalMode("mark");
                  setDummyModalShow(true);
                },
                onUnmarkDummy: (order) => {
                  setOrdersData(order);
                  setDummyModalMode("unmark");
                  setDummyModalShow(true);
                },
              }}
              sourceActionProps={{
                movingItems: workspaceMovingItems,
                onAdvanceSource: (order, source) =>
                  handleStatusModal({ ...order, ...source, order_source_id: source.order_source_id, order_id: order.id }),
                onCancelSource: (source) => reasonHandle(source.order_source_id, "Cancelled"),
                onReturnSource: (source) => reasonHandle(source.order_source_id, "Returned"),
                onMoveItem: moveWorkspaceItemToMall,
                onDownloadAirwayBill: downloadWorkspaceAirwayBill,
                onCopyTracking: copyWorkspaceTracking,
              }}
            />
            <Row className="mt-5 align-items-center">
              <Col className="d-none d-md-block" md="3" lg="3">
                <span className="text-secondary fs-6">{totalOrders} result(s)</span>
              </Col>
              <Col xs="12" md="6" lg="6">
                <PaginationBar currentPage={currentPage} noOfPages={noOfPages} changePage={changePage} />
              </Col>
              <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
                <span className="text-secondary fs-6">{totalOrders} result(s)</span>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <OrdersReasonModal
        show={reasonModal}
        onHide={() => {
          setReasonModal(false);
          setOrderReason({
            order_source_id: null,
            order_id: null,
            status: null,
          });
        }}
        toggle={refreshHandle}
        id={orderReason?.order_source_id}
        status={orderReason?.status}
        trx_status={orderReason?.trx_status}
      />
      <StatusChangeConfirmationModal
        show={changeStatusModal}
        onHide={() => {
          setChangeStatusModal(false);
          setOrderReason({
            order_source_id: null,
            order_id: null,
            status: null,
          });
          setPaymentGatewayResponse(null);
        }}
        toggle={refreshHandle}
        id={orderReason?.order_source_id}
        status={orderReason?.status}
        trx_status={orderReason?.trx_status}
        paymentGatewayResponse={paymentGatewayResponse}
        orderId={orderReason?.order_id}
        orderSourceId={orderReason?.order_source_id}
      />
      <SendSmsModal show={smsModalShow} data={smsModalState} onHide={closeSmsModal} />
      <MarkSpamModal show={spamModalShow} data={ordersData} onHide={closeSpamModal} toggle={refreshHandle} mode={spamModalMode} />
      <ToggleDummyModal show={dummyModalShow} data={ordersData} onHide={closeDummyModal} toggle={refreshHandle} mode={dummyModalMode} />
    </>
  );
};
export default OrdersPage;
